import CheckboxLabel from '../CheckboxLabel'
import type {ComposedFC} from '../../helpers/react-helpers'
import type {ReactNode} from 'react';
import React from 'react'

export const AioCheckbox: ComposedFC<typeof CheckboxLabel,{label: ReactNode},'children'> = ({label,...props}) => <CheckboxLabel {...props}>{label}</CheckboxLabel>

export default AioCheckbox
